import React from 'react'
import { Exercise } from '../../../../../models/Exercise';
import { useTranslation } from 'react-i18next';
import EAChip from '../../../../shared/Chip/EAChip';
import { isToday } from 'date-fns';
import EATooltip from '../../../../shared/EATooltip/EATooltip';

interface IProps {
    exercise: Exercise;
}

const ReservationTag: React.FC<IProps> = ({ exercise }) => {
    const { t } = useTranslation();
    
  return (
    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      {isToday(new Date(exercise.startTime)) && (
        <EATooltip content={t("dzisiaj_tooltip")}>
          <EAChip label={t("dzisiaj")} variant="primary" />
        </EATooltip>
      )}

      {exercise.status === "R" && (
        <EATooltip content={`Lista rezerwowa, jesteś ${exercise.waitListPosition} w kolejce`}>
          <EAChip label={t("lista_rezerwowa")} variant="warning" badge={exercise.waitListPosition} />
        </EATooltip>
      )}

      {exercise.deputyHumanName && (
        <EATooltip content={`${exercise.deputyHumanName} zamiast ${exercise.humanName || t("pierwotny_trener")}`}>
          <EAChip label={t("zastepstwo")} variant="warning" />
        </EATooltip>
      )}
    </div>
  );
};

export default ReservationTag;